var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarryBag7SvgrepoCom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.242,34.594h37.762h37.762c4.973,0,9.004,4.024,9.004,9.001h31.768c0,0,0-16.062,0-23.123 c0-7.054-4.566-13.459-11.475-14.916c-8.821-1.85-18.356-0.876-24.703-1.85C286.888,1.94,264.825,0,256.003,0 c-8.824,0-30.884,1.94-42.355,3.706c-6.347,0.973-15.882,0-24.707,1.85c-6.906,1.457-11.472,7.862-11.472,14.916 c0,7.061,0,23.123,0,23.123h31.767C209.237,38.618,213.269,34.594,218.242,34.594z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.414,120.216H142.593c-23.622,0-42.773,19.153-42.773,42.773V417.17c0,23.619,19.15,42.766,42.773,42.766 h226.821c23.62,0,42.766-19.147,42.766-42.766V162.989C412.18,139.369,393.033,120.216,369.414,120.216z M383.908,417.17 c0,7.993-6.502,14.495-14.495,14.495H142.593c-7.996,0-14.501-6.502-14.501-14.495V162.989c0-7.992,6.505-14.501,14.501-14.501 h226.821c7.993,0,14.495,6.509,14.495,14.501V417.17z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.49,
    y: 54.818,
    className: "st0",
    width: 25.728,
    height: 55.798
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.789,
    y: 54.818,
    className: "st0",
    width: 25.728,
    height: 57.675
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 161.019,
    cy: 490.382,
    r: 21.618
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.985,468.764c-11.94,0-21.614,9.677-21.614,21.618c0,11.941,9.674,21.618,21.614,21.618 c11.941,0,21.618-9.677,21.618-21.618C372.603,478.442,362.926,468.764,350.985,468.764z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.788,205.645H191.213c-5.205,0-9.425,4.218-9.425,9.422c0,5.211,4.22,9.428,9.425,9.428h129.575 c5.204,0,9.425-4.217,9.425-9.428C330.213,209.862,325.992,205.645,320.788,205.645z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.788,278.677H191.213c-5.205,0-9.425,4.218-9.425,9.422c0,5.211,4.22,9.428,9.425,9.428h129.575 c5.204,0,9.425-4.217,9.425-9.428C330.213,282.895,325.992,278.677,320.788,278.677z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.788,351.71H191.213c-5.205,0-9.425,4.218-9.425,9.422c0,5.211,4.22,9.428,9.425,9.428h129.575 c5.204,0,9.425-4.217,9.425-9.428C330.213,355.927,325.992,351.71,320.788,351.71z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarryBag7SvgrepoCom);
export default __webpack_public_path__ + "static/media/carry-bag-7-svgrepo-com.e6e68bd63ef497829b0cadb01f247bfb.svg";
export { ForwardRef as ReactComponent };